import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { IAccountReceivable } from 'safe'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import Datepicker from '../../components/Inputs/Datepicker'
import InputNumber from '../../components/Inputs/InputNumber'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { dateToDB, formatPipe } from '../../utils/utils'
import { IGlobalRate } from '../Sells/Sells'

const server = process.env.REACT_APP_SERVER_URL

const AddPaymentForm: React.FC<IAddPaymentForm> = ({
  onSubmit,
  onClose,
  accountReceivables,
}) => {
  const form = useForm({
    defaultValues: {
      amount: 0,
    },
  })

  const { addAlert } = useSnackBars()

  const [accounts, setAccounts] = useState<any[]>([])

  const [selectedAccount, setSelectedAccount] = useState<any | null>(null)

  const [globalRate, setGlobalRate] = useState<IGlobalRate[]>([])

  const getAccounts = async (): Promise<void> => {
    let response = await axios.get(`${server}/finances/account`)
    setAccounts(response.data.accounts)
    let { accounts } = response.data
    setSelectedAccount({
      text: accounts[0]?.description,
      value: accounts[0]?.id,
    })
  }

  const getGlobalRate = async () => {
    const today = DateTime.local().setLocale('es')
    let date = `${today.year}-${today.month}-${today.day}`
    let response = await axios.get<{ rates: IGlobalRate[]}>(
        `${server}/finances/rate?date=${date}&currency=all`
      )     
    //   console.log("response...", response.data.rate) 
      setGlobalRate(response.data.rates)  
  }

  useEffect(() => {
    getAccounts()
    getGlobalRate()
  }, [])

  let accountTotal = useMemo(() => {
      return accountReceivables.reduce((a, b) => {
        let rate =  globalRate.find((rate) => rate.id === b.currency.id)?.rate || '1'
      return a + +b.totalAmount * +rate
    }, 0)
  }, [accountReceivables, globalRate])

  const submitValue = (values: any) => {
    values.date = dateToDB(values?.date)
    let id = accounts.find((v) => v.id === values.account.id)?.idCurrency
    let objBody = {
      ...values,
      amount: formatPipe(values.amount, true),
      account: { ...values.account, currency: { id } },
    }
    // console.log("objBody...", objBody)
    let rate = globalRate.find((rate) => rate.id === objBody?.account?.currency?.id)?.rate || '1'
    // console.log("rate", rate)

    console.log("VER...", +(+objBody.amount * +rate).toFixed(2))
    console.log("account total", accountTotal)

    if (accountReceivables.length > 1) {
      if ( +(+objBody.amount * +rate).toFixed(2) !== +accountTotal.toFixed(2)) {
        addAlert({
          message: 'El total debe de ser igual a la suma de las cuentas',
          status: 'error',
        })
        return
      }
    }
    onSubmit(objBody)
  }

  return (
    <Form form={form} onSubmit={submitValue} classes="gap-x-4">
      <div className="flex flex-row col-span-12">
        <h2 className="text-xs col-span-12 mb-2 mr-1 font-bold">Nombre:</h2>
        <h2 className="text-xs col-span-12 mb-2">
          {accountReceivables[0]?.client?.name ||
            accountReceivables[0]?.provider?.businessName}
        </h2>
      </div>

      <div className="flex flex-row col-span-12">
        <h2 className="text-xs col-span-12 mb-2 mr-1 font-bold">
          Monto deuda total:
        </h2>
        <h2 className="text-xs col-span-12 mb-2">
          {formatPipe(accountTotal + '')}
        </h2>
      </div>

      {/* <h2 className="text-xs col-span-12 mb-2">Nombre: {accountReceivables[0]?.client?.name || accountReceivables[0]?.provider?.businessName}</h2> */}

      <FormItem
        name="account.id"
        classes="col-span-6 lg:col-span-12"
        rules={{ required: 'Es necesario un nombre' }}
      >
        {/* <InputText label="Cuenta" /> */}
        {/* <InputText label="Tipo" /> */}
        <Select
          options={accounts?.map((v) => ({
            text: v?.description,
            value: v?.id,
          }))}
          value={selectedAccount}
          label="Cuenta"
          onChange={(values) => setSelectedAccount(values)}
        />
      </FormItem>

      <FormItem
        name="amount"
        classes="col-span-3 lg:col-span-6"
        rules={{ required: 'Es necesario un nombre' }}
      >
        {/* <InputText label="Monto" /> */}
        <InputNumber label="Monto" addDecimals={true} />
      </FormItem>

      <FormItem
        name="date"
        classes={`col-span-3 mt-1 lg:col-span-6`}
        rules={{ required: 'Es necesario un nombre' }}
      >
        {/* <InputText label="Fecha" /> */}
        <Datepicker label="Fecha" />
      </FormItem>

      <FormItem
        name="reference"
        classes="col-span-6 lg:row-start-5"
        rules={{ required: 'Es necesario un nombre' }}
      >
        <InputText label="Referencia" isUpperValue={false} />
      </FormItem>

      <FormItem
        name="description"
        classes="col-span-6 lg:row-start-5"
        rules={{ required: 'Es necesario un nombre' }}
      >
        <InputText label="Descripción" isUpperValue={false} />
      </FormItem>

      <div className="flex flex-row col-span-12 mt-5">
        {onClose && (
          <Button
            type="outline"
            classes="w-1/2 mr-4"
            onClick={() => onClose()}
            htmlType="button"
          >
            Cancelar
          </Button>
        )}
        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Guardar cambios
        </Button>
      </div>
    </Form>
  )
}

interface IAddPaymentForm {
  onSubmit: (values: any) => void
  onClose: () => void
  accountReceivables: IAccountReceivable[]
}

export default AddPaymentForm
